export const pkgKeys = {
  CHECK_PKG_USER: () => ['pkg', 'check'],
  FETCH_SETTINGS: () => ['pkg', 'info'],
  CREATE_SIGN_UP: () => ['pkg', 'register'],
  FETCH_OTP: () => ['pkg', 'key']
};
